import React, { useEffect } from "react";
import * as H from "history";
import {
  Breadcrumb,
  IBreadcrumbItem,
  Pivot,
  PivotItem,
  Separator,
  Stack,
} from "@fluentui/react";
import { CustomerAddAddress } from "./CustomerAddAddress";
import { BreadcrumbStyle } from "../../Quotation/AddQuotation/AddQuotationStyle";
import { ResponseCustomerEditAccount } from "../Customer.types";
import { useLocation } from "react-router";

interface IAccountsProps {
  history?: H.History;
  onCustomerAccount: (isCustomerAccount: boolean) => void;
}

export const CustomerEditAddress: React.FunctionComponent<IAccountsProps> = (
  props
) => {
  const stackTokens = { childrenGap: 10 };
  const location = useLocation();
  const params = location && (location?.state as ResponseCustomerEditAccount);
  const paramsType = location && (location?.state as any).selectedAddress;

  console.log("paramsType", paramsType);

  const getBreadcrumbItems = () => {
    const items: IBreadcrumbItem[] = [
      { text: "Customers Records", key: "Customers Records" },
    ];
    if (params?.name) {
      items.push({
        text: params?.name,
        key: params?.name,
        isCurrentItem: true,
      });
    }
    return items;
  };

  useEffect(() => {
    props.onCustomerAccount(true);
  }, []);

  return (
    <Stack
      style={{
        marginLeft: "10px",
        marginRight: "10px",
        background: "white",
      }}
      tokens={stackTokens}
    >
      <Breadcrumb
        items={getBreadcrumbItems()}
        style={{ marginLeft: "1%", marginBottom: "-5px" }}
        styles={BreadcrumbStyle}
      />
      <Separator />
      <Stack style={{ marginTop: "-10px" }}>
        {paramsType === "Billing" ? (
          <Pivot aria-label="All">
            <PivotItem key="Billing" headerText="Bill To">
              <CustomerAddAddress
                addressType="Billing"
                onCustomerAccount={props.onCustomerAccount}
              />
            </PivotItem>
            <PivotItem key="Shipping" headerText="Ship To">
              <CustomerAddAddress
                addressType="Shipping"
                onCustomerAccount={props.onCustomerAccount}
              />
            </PivotItem>
          </Pivot>
        ) : (
          <Pivot aria-label="All">
            <PivotItem key="Shipping" headerText="Ship To">
              <CustomerAddAddress
                addressType="Shipping"
                onCustomerAccount={props.onCustomerAccount}
              />
            </PivotItem>
            <PivotItem key="Billing" headerText="Bill To">
              <CustomerAddAddress
                addressType="Billing"
                onCustomerAccount={props.onCustomerAccount}
              />
            </PivotItem>
          </Pivot>
        )}
      </Stack>
    </Stack>
  );
};
